import {
    setUserInfo,
    toggleLoading,
    toggleSnackBar
} from './'

import {
    req
} from '../../util'

export const login = ({
    username,
    password,
    rememberMe
}) => dispatch => {
    dispatch(toggleLoading());
    req('post', 'auth/login', {
        username,
        password
    }, false,false).then(res => {
        let {
            success,
            msg,
            token
        } = res;
        if (success) {
            try {
                let i = token.split('.')
                let userInfo = JSON.parse(atob(i[1]))
                let user = {...userInfo,token}
                dispatch(setUserInfo(user))
                dispatch(toggleLoading());
                dispatch(toggleSnackBar(`Welcome ${userInfo.name}`))
                if (rememberMe) {
                    localStorage.setItem('token', token)
                }
                return;
            } catch (e) {
                dispatch(toggleLoading());
                dispatch(toggleSnackBar("Invalid login"))
                console.error(e)
                return;
            }
        }
        dispatch(toggleLoading());
        dispatch(toggleSnackBar(msg))
    }).catch(e => {
        dispatch(toggleLoading());
        dispatch(toggleSnackBar("Network error"))
        console.error(e)
    })
}